// const storage = {
//     getItem: (key) => localStorage.getItem(key),
//     setItem: (key, value) => localStorage.setItem(key, value),
//     removeItem: (key) => localStorage.removeItem(key),
// };

// const SOCKET_URL = "wss://rem-crm.ru:3000/activity";

// class WebSocketService {
//     constructor() {
//         this.ws = null;
//         this.listeners = {};
//         this.reconnectAttempts = 0;
//         this.maxReconnectAttempts = 5;
//         this.reconnectDelay = 1000;
//         this.token = null;
//         this.pendingRequests = [];
//         this.pendingCallbacks = new Map();
//         this.connectPromise = null;
//     }

//     async connect() {
//         if (this.connectPromise) return this.connectPromise;
//         this.connectPromise = this._connect();
//         return this.connectPromise;
//     }

//     async _connect() {
//         this.token = await storage.getItem("@auth_token");
//         console.log("Токен загружен:", this.token ? "есть" : "нет");
//         return new Promise((resolve, reject) => {
//             this.ws = new WebSocket(SOCKET_URL);
//             this.ws.onopen = () => {
//                 console.log("WebSocket подключён");
//                 this.reconnectAttempts = 0;
//                 this.trigger("connected");
//                 this.pendingRequests.forEach((req) => this.send(req));
//                 this.pendingRequests = [];
//                 resolve();
//             };
//             this.ws.onmessage = (event) => {
//                 try {
//                     const data = JSON.parse(event.data);
//                     if (data.requestId && this.pendingCallbacks.has(data.requestId)) {
//                         const { resolve, reject } = this.pendingCallbacks.get(data.requestId);
//                         this.pendingCallbacks.delete(data.requestId);
//                         data.error ? reject(new Error(data.error)) : resolve(data);
//                         return;
//                     }
//                     if (data.results) this.trigger("data", data.results);
//                     else if (data.error) this.trigger("error", data.error);
//                 } catch (e) {}
//             };
//             this.ws.onerror = (error) => {
//                 this.trigger("error", error);
//                 reject(error);
//             };
//             this.ws.onclose = (event) => {
//                 this.trigger("disconnected", event.reason);
//                 this.connectPromise = null;
//                 if (this.reconnectAttempts < this.maxReconnectAttempts) {
//                     this.reconnectAttempts++;
//                     setTimeout(() => this.connect(), this.reconnectDelay);
//                 }
//             };
//         });
//     }

//     disconnect() {
//         if (this.ws) {
//             this.ws.close();
//             this.ws = null;
//             this.connectPromise = null;
//         }
//     }

//     request(tip, page, data = {}) {
//         if (!this.token) {
//             this.connect().then(() => this.request(tip, page, data));
//             return;
//         }
//         this.send({ token: this.token, tip, page, data });
//     }

//     requestWithPromise(tip, page, data = {}, timeoutMs = 5000) {
//         return new Promise((resolve, reject) => {
//             if (!this.token) {
//                 this.connect()
//                     .then(() => this.requestWithPromise(tip, page, data, timeoutMs))
//                     .then(resolve)
//                     .catch(reject);
//                 return;
//             }
//             const requestId = `${Date.now()}_${Math.random().toString(36)}`;
//             const message = { token: this.token, tip, page, data, requestId };
//             this.pendingCallbacks.set(requestId, { resolve, reject });
//             this.send(message);
//             const timeout = setTimeout(() => {
//                 if (this.pendingCallbacks.has(requestId)) {
//                     this.pendingCallbacks.delete(requestId);
//                     reject(new Error("Timeout waiting for response"));
//                 }
//             }, timeoutMs);
//             const wrappedResolve = (value) => {
//                 clearTimeout(timeout);
//                 resolve(value);
//             };
//             this.pendingCallbacks.set(requestId, { resolve: wrappedResolve, reject });
//         });
//     }

//     async getOrderByNotification(masterId, orderId) {
//         const response = await this.requestWithPromise("app", "app/getOrderByNotification", { masterId, orderId });
//         if (response.kn_order) return response.kn_order;
//         throw new Error(response.error || "Order not found");
//     }

//     fetchAvailableOrders(params = {}) {
//         this.request("app", "app/getOrders", params);
//     }
//     fetchAvailableOrdersPis(params = {}) {
//         this.request("app", "app/getOrdersPis", params);
//     }
//     fetchMyOrders(params = {}) {
//         this.request("app", "app/getMyOrders", params);
//     }
//     fetchReports(params = {}) {
//         this.request("app", "app/getReports", params);
//     }
//     takeOrder(orderId, params = {}) {
//         this.request("app", "app/getTakeOrder", { orderId, ...params });
//     }
//     completeOrder(orderId, reportData = {}, params = {}) {
//         this.request("app", "app/getCompleteOrder", { orderId, ...reportData, ...params });
//     }

//     send(obj) {
//         console.log("📤 [WS] Отправка:", obj);
//         if (this.ws && this.ws.readyState === WebSocket.OPEN) {
//             this.ws.send(JSON.stringify(obj));
//         } else {
//             this.pendingRequests.push(obj);
//             if (!this.connectPromise) this.connect();
//         }
//     }

//     on(event, callback) {
//         if (!this.listeners[event]) this.listeners[event] = [];
//         this.listeners[event].push(callback);
//     }
//     off(event, callback) {
//         if (!this.listeners[event]) return;
//         this.listeners[event] = this.listeners[event].filter((cb) => cb !== callback);
//     }
//     trigger(event, data) {
//         if (this.listeners[event]) this.listeners[event].forEach((cb) => cb(data));
//     }
//     isConnected() {
//         return this.ws && this.ws.readyState === WebSocket.OPEN;
//     }
// }

// const wsService = new WebSocketService();
// export default wsService;

const storage = {
    getItem: (key) => localStorage.getItem(key),
    setItem: (key, value) => localStorage.setItem(key, value),
    removeItem: (key) => localStorage.removeItem(key),
};

// WebSocket через текущий домен
const SOCKET_URL = `wss://${window.location.host}/ws`;

class WebSocketService {
    constructor() {
        this.ws = null;
        this.listeners = {};
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.reconnectDelay = 1000;
        this.token = null;
        this.pendingRequests = [];
        this.pendingCallbacks = new Map();
        this.connectPromise = null;
    }

    async connect() {
        if (this.connectPromise) return this.connectPromise;
        this.connectPromise = this._connect();
        return this.connectPromise;
    }

    async _connect() {
        this.token = await storage.getItem("@auth_token");
        console.log("Токен загружен:", this.token ? "есть" : "нет");
        return new Promise((resolve, reject) => {
            this.ws = new WebSocket(SOCKET_URL);
            this.ws.onopen = () => {
                console.log("WebSocket подключён");
                this.reconnectAttempts = 0;
                this.trigger("connected");
                this.pendingRequests.forEach((req) => this.send(req));
                this.pendingRequests = [];
                resolve();
            };
            this.ws.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    if (data.requestId && this.pendingCallbacks.has(data.requestId)) {
                        const { resolve, reject } = this.pendingCallbacks.get(data.requestId);
                        this.pendingCallbacks.delete(data.requestId);
                        data.error ? reject(new Error(data.error)) : resolve(data);
                        return;
                    }
                    if (data.results) this.trigger("data", data.results);
                    else if (data.error) this.trigger("error", data.error);
                } catch (e) {}
            };
            this.ws.onerror = (error) => {
                this.trigger("error", error);
                reject(error);
            };
            this.ws.onclose = (event) => {
                this.trigger("disconnected", event.reason);
                this.connectPromise = null;
                if (this.reconnectAttempts < this.maxReconnectAttempts) {
                    this.reconnectAttempts++;
                    setTimeout(() => this.connect(), this.reconnectDelay);
                }
            };
        });
    }

    disconnect() {
        if (this.ws) {
            this.ws.close();
            this.ws = null;
            this.connectPromise = null;
        }
    }

    request(tip, page, data = {}) {
        if (!this.token) {
            this.connect().then(() => this.request(tip, page, data));
            return;
        }
        this.send({ token: this.token, tip, page, data });
    }

    requestWithPromise(tip, page, data = {}, timeoutMs = 5000) {
        return new Promise((resolve, reject) => {
            if (!this.token) {
                this.connect()
                    .then(() => this.requestWithPromise(tip, page, data, timeoutMs))
                    .then(resolve)
                    .catch(reject);
                return;
            }
            const requestId = `${Date.now()}_${Math.random().toString(36)}`;
            const message = { token: this.token, tip, page, data, requestId };
            this.pendingCallbacks.set(requestId, { resolve, reject });
            this.send(message);
            const timeout = setTimeout(() => {
                if (this.pendingCallbacks.has(requestId)) {
                    this.pendingCallbacks.delete(requestId);
                    reject(new Error("Timeout waiting for response"));
                }
            }, timeoutMs);
            const wrappedResolve = (value) => {
                clearTimeout(timeout);
                resolve(value);
            };
            this.pendingCallbacks.set(requestId, { resolve: wrappedResolve, reject });
        });
    }

    async getOrderByNotification(masterId, orderId) {
        const response = await this.requestWithPromise("app", "app/getOrderByNotification", { masterId, orderId });
        if (response.kn_order) return response.kn_order;
        throw new Error(response.error || "Order not found");
    }

    fetchAvailableOrders(params = {}) {
        this.request("app", "app/getOrders", params);
    }
    fetchAvailableOrdersPis(params = {}) {
        this.request("app", "app/getOrdersPis", params);
    }
    fetchMyOrders(params = {}) {
        this.request("app", "app/getMyOrders", params);
    }
    fetchReports(params = {}) {
        this.request("app", "app/getReports", params);
    }
    takeOrder(orderId, params = {}) {
        this.request("app", "app/getTakeOrder", { orderId, ...params });
    }
    completeOrder(orderId, reportData = {}, params = {}) {
        this.request("app", "app/getCompleteOrder", { orderId, ...reportData, ...params });
    }

    send(obj) {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) this.ws.send(JSON.stringify(obj));
        else {
            this.pendingRequests.push(obj);
            if (!this.connectPromise) this.connect();
        }
    }

    on(event, callback) {
        if (!this.listeners[event]) this.listeners[event] = [];
        this.listeners[event].push(callback);
    }
    off(event, callback) {
        if (!this.listeners[event]) return;
        this.listeners[event] = this.listeners[event].filter((cb) => cb !== callback);
    }
    trigger(event, data) {
        if (this.listeners[event]) this.listeners[event].forEach((cb) => cb(data));
    }
    isConnected() {
        return this.ws && this.ws.readyState === WebSocket.OPEN;
    }
}

const wsService = new WebSocketService();
export default wsService;
